import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import VConsole from "vconsole";
import { ensureTenantId } from "./contexts/AuthContext";
import { COLORS } from "./constants";
import { brandConfig } from "./config/brand";

const applyGlobalColorVariables = () => {
  const root = document.documentElement;

  root.style.setProperty("--color-background-app", brandConfig.palette.bodyBackground);
  root.style.setProperty("--color-app-header-bg", COLORS.background.appSecondary);
  root.style.setProperty("--color-common-white", COLORS.common.white);
  root.style.setProperty("--color-app-link", COLORS.brand.gradientStart);
  root.style.setProperty("--color-slick-dot", COLORS.text.onDarkPlaceholder);
  root.style.setProperty("--color-slick-dot-active", COLORS.background.accentMuted);
};

// Persist tenantId BEFORE any LIFF redirect happens.
// LINE rich-menu URL carries ?tanantId=xxx (or ?tenantId=xxx) on the very
// first open. LIFF may redirect to OAuth and the query string is lost on
// the return trip, so we must save it to localStorage right here.
ensureTenantId();
applyGlobalColorVariables();

const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

if (import.meta.env.VITE_MODE === "development" || import.meta.env.VITE_MODE === "staging" && isMobile) {
  const console = new VConsole();
  console.setOption("maxLogNumber", 1000);
  globalThis.window.__vconsoleInstance__ = console;
}

if (import.meta.env.VITE_MODE === "production" && isMobile) {
  const console = new VConsole();
  console.setOption("maxLogNumber", 1000);
  console.hideSwitch?.();
  console.hide?.();
  globalThis.window.__vconsoleInstance__ = console;
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
